import React, { createContext, useCallback, useState } from 'react';

export const ToggleFilterVisibleStateContext = createContext();
export const ToggleFilterVisibleDispatchContext = createContext();

export const FilterVisibleProvider = ({ children }) => {
  const [filterVisible, setFilterVisible] = useState(false);
  const toggleFilter = useCallback(() => setFilterVisible((prev) => !prev), []);

  return (
    <ToggleFilterVisibleStateContext.Provider value={filterVisible}>
      <ToggleFilterVisibleDispatchContext.Provider value={toggleFilter}>
        {children}
      </ToggleFilterVisibleDispatchContext.Provider>
    </ToggleFilterVisibleStateContext.Provider>
  );
};
